/* istanbul ignore file */
export class LinkedListNode {
    constructor(value, next = null) {
        this.value = value;
        this.next = next;
    }
}
export class LinkedList {
    constructor(head = null, tail = null) {
        this.head = head;
        this.tail = tail;
        this.head = null;
        this.tail = null;
    }
    empty() {
        return this.head === null;
    }
    prepend(value) {
        const newNode = new LinkedListNode(value, this.head);
        this.head = newNode;
        if (!this.tail) {
            this.tail = newNode;
        }
        return this;
    }
    append(value) {
        const newNode = new LinkedListNode(value);
        if (!this.head) {
            this.head = newNode;
            this.tail = newNode;
            return this;
        }
        this.tail.next = newNode;
        this.tail = newNode;
        return this;
    }
    deleteHead() {
        if (!this.head) {
            return null;
        }
        const deletedHead = this.head;
        if (this.head.next) {
            this.head = this.head.next;
        }
        else {
            this.head = null;
            this.tail = null;
        }
        return deletedHead;
    }
}
export class DoublyLinkedListNode {
    constructor(value, next = null, previous = null) {
        this.value = value;
        this.next = next;
        this.previous = previous;
    }
}
export class DoublyLinkedList {
    constructor(head = null, tail = null) {
        this.head = head;
        this.tail = tail;
    }
    prepend(value) {
        const newNode = new DoublyLinkedListNode(value, this.head);
        if (this.head) {
            this.head.previous = newNode;
        }
        this.head = newNode;
        if (!this.tail) {
            this.tail = newNode;
        }
        return this;
    }
    append(value) {
        const newNode = new DoublyLinkedListNode(value);
        if (!this.head) {
            this.head = newNode;
            this.tail = newNode;
            return this;
        }
        this.tail.next = newNode;
        newNode.previous = this.tail;
        this.tail = newNode;
        return this;
    }
    deleteTail() {
        if (!this.tail) {
            return null;
        }
        if (this.head === this.tail) {
            const deletedTail = this.tail;
            this.head = null;
            this.tail = null;
            return deletedTail;
        }
        const deletedTail = this.tail;
        this.tail = this.tail.previous;
        this.tail.next = null;
        return deletedTail;
    }
    deleteHead() {
        if (!this.head) {
            return null;
        }
        const deletedHead = this.head;
        if (this.head.next) {
            this.head = this.head.next;
            this.head.previous = null;
        }
        else {
            this.head = null;
            this.tail = null;
        }
        return deletedHead;
    }
    empty() {
        return this.head === null;
    }
}
